import React, { useEffect } from "react";

import FASTable from "../../../../../components/Tables/FASTable";
import Cookies from "js-cookie";
import { useDispatch, useSelector } from "react-redux";
import {
  CustomerSupplierLedgerMonthFun,
  CustomerSupplierProAcDetail,
  CustomerSupplierProLedgerMonth,
} from "../../../../../Redux/Slice/Fas/Profile Analysis/Customer/CustomerSlice";
import { Loader } from "../../../../../components/Loader/Loader";
import { format } from "date-fns/esm";
import { useTheme } from "../../../../../Themecontext/Themecontext";

export default function MonthLedger({
  accountName,
  accountGroup,
  startDate,
  endDate,
}) {
  const dispatch = useDispatch();
  const { Colourdata } = useSelector((state) => state.ClientLogin);
  const { CustomerSupplierLedgerMonthdata } = useSelector(
    (state) => state.CustomerSlice,
  );

  const iscolour = Colourdata?.data?.find((el) => el.ExeName === "NEWFAS");
  const iscolourDark = Colourdata?.data?.find(
    (el) => el.ExeName === "NEWFASDARK",
  );

  const { theme } = useTheme();
  const isdark = theme;
  const Firm = Cookies.get("Firm");
  const YearId = Cookies.get("FinancialYear");
  useEffect(() => {
    dispatch(CustomerSupplierLedgerMonthFun());
    dispatch(
      CustomerSupplierProLedgerMonth({
        Firm,
        Year: YearId,
        AcIDs: accountName.join(","),
        selectedIds: accountGroup.join(","),
        startDate: startDate,
        endDate: endDate,
      }),
    );
    dispatch(CustomerSupplierProAcDetail({ AcIDs: accountName }));
  }, [dispatch, YearId, Firm, accountName]);

  const getRows = CustomerSupplierLedgerMonthdata?.CustData?.map(
    (label, index) => ({
      // srNumber: index + 1,
      TransactionName: label.TransactionName,
      AprBalAmt: label.AprBalAmt,
      MayBalAmt: label.MayBalAmt,
      JunBalAmt: label.JunBalAmt,
      JulBalAmt: label.JulBalAmt,
      AugBalAmt: label.AugBalAmt,
      SepBalAmt: label.SepBalAmt,
      OctBalAmt: label.OctBalAmt,
      NovBalAmt: label.NovBalAmt,
      DecBalAmt: label.DecBalAmt,
      JanBalAmt: label.JanBalAmt,
      FebBalAmt: label.FebBalAmt,
      MarBalAmt: label.MarBalAmt,
      Amount: label.Amount,
    }),
  );

  const getColumns = [
    { label: "Chart", key: "charts", align: "center" },
    { label: "Sr. No.", key: "srNumber", align: "center" },
    {
      label: "Transaction Name",
      key: "TransactionName",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    { label: "Total Balance", key: "Amount", align: "right", format: "true" },
    { label: "Apr", key: "AprBalAmt", align: "right", format: "true" },
    { label: "May", key: "MayBalAmt", align: "right", format: "true" },
    { label: "Jun", key: "JunBalAmt", align: "right", format: "true" },
    { label: "Jul", key: "JulBalAmt", align: "right", format: "true" },
    { label: "Aug", key: "AugBalAmt", align: "right", format: "true" },
    { label: "Sep", key: "SepBalAmt", align: "right", format: "true" },
    { label: "Oct", key: "OctBalAmt", align: "right", format: "true" },
    { label: "Nov", key: "NovBalAmt", align: "right", format: "true" },
    { label: "Dec", key: "DecBalAmt", align: "right", format: "true" },
    { label: "Jan", key: "JanBalAmt", align: "right", format: "true" },
    { label: "Feb", key: "FebBalAmt", align: "right", format: "true" },
    { label: "Mar", key: "MarBalAmt", align: "right", format: "true" },
  ];
  if (
    CustomerSupplierLedgerMonthdata === "no" ||
    CustomerSupplierLedgerMonthdata === null
  ) {
    return (
      <div className="flex justify-center items-center h-screen text-xl text-[#502000]">
        <Loader />
      </div>
    );
  }

  return (
    <div style={{ marginTop: "20px" }}>
      <div
        style={{
          borderRadius: "12px",
          overflow: "hidden",
          boxShadow: "0 4px 10px rgba(0,0,0,0.27)",
        }}
      >
        <div
          style={{
            backgroundColor:
              isdark === "light" ? iscolour?.Colour5 : iscolourDark?.Colour4,
            color:
              isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour11,
            padding: "14px",
            margin: 0,
          }}
        >
          <h2
            style={{
              fontSize: "18px",
              margin: 0,
              letterSpacing: "1px",
              fontWeight: "600",
            }}
          >
            MONTHLY LEDGER
          </h2>
        </div>
        <FASTable
          data={getRows}
          columns={getColumns}
          externalTotals={CustomerSupplierLedgerMonthdata?.CustSummary?.[0]}
        />
      </div>
    </div>
  );
}
